import * as types from '../constants/actionTypes';
import {wrapCall} from '../utils/serviceUtils';
import {api, API_ROOT} from '../utils/services';
import {isArray} from "lodash";
import auth from "../utils/auth";
import constants from "src/js/constants";
import {getFilterAsQueryString} from "src/js/utils/routeUtils";

export const checkCode = (code) => {
  const data = {
    screenId: auth.getScreenId(),
    code: code,
    locale: auth.getLocale(),
    platform: constants.app.platform,
    appVersion: constants.app.appVersion
  }
  return wrapCall(
    api.post(`auth/screens`, data),
    types.DO_LOGIN_SCREEN
  );
};

export const resetManageScreenErrMsg = () => {
  return {
    type: types.RESET_MANAGE_SCREEN_ERROR_MESSAGE
  }
};

export const fetchScreen = (id) => {
  return wrapCall(
    api.get(`/userB/screens/${id}`),
    types.FETCH_SCREEN,
  );
};
export const manageScreen = (data, id) => {
  return wrapCall(
    api.post(`/userB/screens${id ? '/'+ id : ''}`, data),
    types.MANAGE_SCREEN,
  );
};

export const fetchCacheActivities = () => {
  return {
    type: types.FETCH_CACHE_FUN_ACTIVITIES,
  }
};
export const fetchActivities = (fetchCounter, page = 1, perPage = 10) => {
  return wrapCall(
    api.get(`/showcase/funs?page=${page}&perPage=${perPage}`),
    types.FETCH_FUN_ACTIVITIES_SHOWCASE,
    {requestData: {fetchCounter}}
  );
};
export const logShowcaseFunPreview = (activity) => {
  return wrapCall(
    api.post(`showcase/funs/preview/${activity.id}`, {'aType': activity.type, 'aBusinessId': activity.cBusinessId}),
    types.LOG_FUN_ACTIVITY_SHOWCASE
  );
};

export const postUserInfo = (data) => {
  data.device = {
    platform: constants.app.platform,
    appVersion: constants.app.appVersion
  };
  return wrapCall(
    api.post(`showcase/user`, data),
    types.POST_SHOWCASE_USER_INFO
  );
};

export const fetchActivity = (id, blockedLoading, geoLocation, skipQuestion) => {
  return wrapCall(
    api.get(`/user/activities/${id}?inDetail=1${skipQuestion ? '&nq=1' : ''}${geoLocation ? '&latitude='+ geoLocation.latitude +'&longitude='+ geoLocation.longitude +'&map='+ (geoLocation.inMap ? 1 : 0) : ''}`),
    blockedLoading ? types.FETCH_FUN_ACTIVITY_BLOCKED_LOADING : types.FETCH_FUN_ACTIVITY,
    {id}
  );
};
export const fetchActivityReviews = (id, page, perPage = 10, postId = null) => {
  return wrapCall(
    api.get(`/user/activityReviews?page=${page}&perPage=${perPage}&activityId=${id}${postId ? '&postId=' + postId : ''}`),
    types.GET_ACTIVITY_REVIEWS,
    {id}
  );
};
export const fetchUserActivityReviews = (userId, page, perPage = 10, postId = null) => {
  return wrapCall(
    api.get(`/user/activityReviews?page=${page}&perPage=${perPage}&createdById=${userId}&createdByType=1${postId ? '&postId=' + postId : ''}`),
    types.GET_ACTIVITY_REVIEWS,
    {userId}
  );
};
export const fetchOpenActivityReviews = (id, page, perPage = 10, postId = null, activityType = null) => {
  return wrapCall(
    api.get(`/activityReviews?page=${page}&perPage=${perPage}&activityId=${id}${postId ? '&postId=' + postId : ''}${activityType ? '&activityTypes=' + activityType : ''}`),
    types.GET_ACTIVITY_REVIEWS,
    {id}
  );
};
export const makeActionInActivity = (id, data, withBlockedLoading = false) => {
  return wrapCall(
    api.post(`/user/activities/state/${id}`, data),
    withBlockedLoading ? types.MAKE_ACTION_IN_ACTIVITY_BLOCKING : types.MAKE_ACTION_IN_ACTIVITY,
  );
};
export const makePreActionInActivity = (data, withBlockedLoading) => {
  return wrapCall(
    api.post(`/user/activities/gameData`, data),
    withBlockedLoading ? types.MAKE_ACTION_IN_ACTIVITY_BLOCKING : types.MAKE_ACTION_IN_ACTIVITY,
  );
};

export const fetchOpenActivityWinners = (id, page = 1, perPage = 50) => {
  return wrapCall(
    api.get(`/activities/winners/${id}?page=${page}&perPage=${perPage}`),
    types.FETCH_FUN_WINNERS,
    {id}
  );
};
export const fetchActivityWinners = (id, page = 1, perPage = 50) => {
  return wrapCall(
    api.get(`/user/activities/winners/${id}?page=${page}&perPage=${perPage}`),
    types.FETCH_FUN_WINNERS,
    {id}
  );
};
export const fetchActivityDummyWinners = (id, page = 1, perPage = 10) => {
  return {
    type: types.FETCH_FUN_DUMMY_WINNERS,
    id
  };
};
export const notifyActivityWinner = (id) => {
  return wrapCall(
    api.get(`/userB/activities/notifyWinners/${id}`),
    types.NOTIFY_ACTIVITY_WINNER,
    {id}
  );
};

export const fetchOpenActivityPlayerStats = (id, page = 1, perPage = 50) => {
  return wrapCall(
    api.get(`/activities/players/${id}?page=${page}&perPage=${perPage}`),
    types.FETCH_FUN_WINNERS,
    {id}
  );
};
export const fetchActivityPlayerStats = (id, page = 1, perPage = 50) => {
  return wrapCall(
    api.get(`/user/activities/players/${id}?page=${page}&perPage=${perPage}`),
    types.FETCH_FUN_WINNERS,
    {id}
  );
};
export const fetchActivityDummyPlayerStats = (id, page = 1, perPage = 10) => {
  return {
    type: types.FETCH_FUN_DUMMY_WINNERS,
    id
  };
};

export const fetchActivityAnswerDistributions = (id) => {
  return wrapCall(
    api.get(`/user/activities/answerDistribution/${id}`),
    types.FETCH_FUN_ANSWER_DISTRIBUTIONS,
    {id}
  );
};
export const fetchDummyActivityAnswerDistributions = (id, data) => {
  return {
    type: types.FETCH_DUMMY_FUN_ANSWER_DISTRIBUTIONS,
    id,
    data
  };
};

export const reportActivity = (data) => {
  const id = data.id;
  return wrapCall(
    api.post(`/user/spammedActivities`, data),
    types.ACTIVITY_REPORT,
    {id}
  );
};

export const reportActivityPost = (data) => {
  const id = data.id;
  return wrapCall(
    api.post(`/user/spammedActivityReviews`, data),
    types.ACTIVITY_POST_REPORT,
    {id}
  );
};

export const deleteActivityPost = (id) => {
  return wrapCall(
    api.delete(`/user/activityReviews/${id}`),
    types.ACTIVITY_POST_DELETE,
    {id}
  );
};

export const likeActivityPost = (data) => {
  const id = data.id;
  return wrapCall(
    api.post(`/user/activityReviewLikes`, data),
    types.ACTIVITY_POST_ACTION_BG,
    {id}
  );
};

export const previewActivityPost = (id) => {
  return wrapCall(
    api.post(`/user/activityReviews/previews/${id}`, {id: id}),
    types.ACTIVITY_POST_ACTION_BG,
    {id}
  );
};

export const downloadActivityPost = (id, onDownloadProgress) => {
  return wrapCall(
    api.get(`/user/activityReviews/downloads/${id}`, null, {responseType: 'blob', onDownloadProgress: onDownloadProgress}),
    types.DOWNLOAD_ACTIVITY_REVIEW,
    {id}
  );
};

export const postActivityPost = (data, onUploadProgress) => {
  const formData = new FormData();
  for (let key in data) {
    if (isArray(data[key])) {
      const arr = data[key];
      for (var i = 0; i < arr.length; i++) {
        formData.append(`${key}[]`, arr[i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  formData.append('token', auth.getToken());

  const url = `/user/activities/state/${data.id}`;
  return wrapCall(
    api.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}, onUploadProgress: onUploadProgress}),
    types.ACTIVITY_ADD_POST,
  );
};


export const gameMediaProcessUrl = (tmpId, path, type, number) => {
  if (type === 'audio') {
    const fileName = path.substring(path.lastIndexOf('/') + 1); // added dummy file name that is having the extension since then only it gets loaded to phaserjs
    return `${API_ROOT}/screensProcessMedia/${fileName}?tmpId=${tmpId}&path=${path}&type=${type}&number=${number}`;
  }
  return `${API_ROOT}/screensProcessMedia?tmpId=${tmpId}&path=${path}&type=${type}&number=${number}`;
};

export const resetScreensError = () => {
  return {
    type: types.RESET_SCREENS_ERROR,
  };
};
export const fetchCacheScreens = () => {
  return {
    type: types.FETCH_CACHE_SCREENS,
  }
};
export const fetchScreens = (page, perPage, isLoadingDisabled = false) => {
  return wrapCall(
    api.get(`/userB/screens?page=${page}&perPage=${perPage || 10}`),
    types.FETCH_SCREENS,
    {page, isLoadingDisabled}
  );
};

export const updateScreenOrientation = (id, orientation) => {
  return wrapCall(
    api.post(`/userB/screens/orientation/${id}`, {orientation: orientation}),
    types.UPDATE_SCREEN_ORIENTATION,
    {id, orientation}
  );
};
export const toggleScreenState = (id, newState) => {
  return wrapCall(
    api.post(`/userB/screens/state/${id}`, {state: newState}),
    types.TOGGLE_SCREEN_STATE,
    {id, newState}
  );
};
export const deleteScreen = (id) => {
  return wrapCall(
    api.delete(`/userB/screens/${id}`),
    types.DELETE_SCREEN,
    {id}
  );
};

export const resetScreenCampaignRequestsError = () => {
  return {
    type: types.RESET_SCREEN_CAMPAIGN_REQUESTS_ERROR,
  };
};
export const fetchCacheScreenCampaignRequests = () => {
  return {
    type: types.FETCH_CACHE_SCREEN_CAMPAIGN_REQUESTS,
  }
};
export const fetchScreenCampaignRequests = (state, page, screenId) => {
  const baseUrl = screenId ? `/userB/screenManageCampaigns/${screenId}` : `/userB/screenRequests`;
  return wrapCall(
    api.get(`${baseUrl}?state=${state}&page=${page}&perPage=${constants.table.perPage}`),
    types.FETCH_SCREEN_CAMPAIGN_REQUESTS,
    {page}
  );
};
export const updateScreenCampaignRequests = (data, screenId) => {
  const baseUrl = screenId ? `/userB/screenManageCampaigns/${screenId}` : `/userB/screenRequests`;
  return wrapCall(
    api.post(baseUrl, data),
    types.RESPOND_SCREEN_CAMPAIGN_REQUEST_STATE,
    {request: {activityId: data.activityId}}
  );
};
export const controlScreenCampaignRequests = (approval, silent = false, screenId) => {
  const baseUrl = screenId ? `/userB/screenManageCampaigns/settings/${screenId}` : `/userB/screenRequests/settings`;
  return wrapCall(
    api.post(baseUrl, {approval: approval}),
    silent ? types.CONTROL_SCREEN_CAMPAIGN_REQUESTS_SILENT : types.CONTROL_SCREEN_CAMPAIGN_REQUESTS,
    {request: {showAutoApproval: approval}}
  );
};

export const fetchScreenInsightConfigs = (id) => {
  return wrapCall(
    api.get(`/userB/screenInsightConfigs/${id}`),
    types.FETCH_ACTIVITY_INSIGHT_CONFIGS,
    {id}
  );
};

export const fetchScreenInsight = (id, chartId, focusId, filters) => {
  return wrapCall(
    api.get(`/userB/screenInsight/${id}?c=${chartId}&a=${focusId}${filters ? '&' + getFilterAsQueryString(filters) : ''}`),
    types.FETCH_ACTIVITY_INSIGHT,
    {id}
  );
};
